import { UserBtnHandlers } from '@/src/lib/MayzSmartDB/FrontEnd/index';
import { useAppStore, useWalletStore } from '@/src/store/global/index';
import { TaskComponentProps, TxComponentProps } from '@/src/types/index';
import { useEffect, useState } from 'react';

export default function useGetTokenGovTx({ ...props }: {} & TxComponentProps & TaskComponentProps) {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const walletStore = useWalletStore();
    const appStore = useAppStore();
    //--------------------------------------
    const [amount, setAmount] = useState(0n);
    //--------------------------------------
    const [isProcessingTx, setIsProcessingTx] = useState(false);
    const [isFaildedTx, setIsFaildedTx] = useState(false);
    const [isConfirmedTx, setIsConfirmedTx] = useState(false);
    const [processingTxMessage, setProcessingTxMessage] = useState('');
    const [processingTxHash, setProcessingTxHash] = useState('');
    const [isValidTx, setIsValidTx] = useState(true);
    //--------------------------------------
    useEffect(() => {
        appStore.setIsProcessingTx(isProcessingTx);
    }, [isProcessingTx]);
    //--------------------------------------
    const resetForm = async () => {
        setAmount(0n);
    };
    //--------------------------------------
    useEffect(() => {
        if (amount > 0n) {
            setIsValidTx(true);
        } else {
            setIsValidTx(false);
        }
    }, [amount]);
    //--------------------------------------
    const handleBtnGetTokenGovTx = async () => {
        try {
            props.scrollToTask?.();
            setIsProcessingTx(true);
            setIsFaildedTx(false);
            setIsConfirmedTx(false);
            setProcessingTxMessage('');
            setProcessingTxHash('');
            if (
                isValidTx &&
                (await UserBtnHandlers.handleBtnGetTokenGovTx(setProcessingTxMessage, setProcessingTxHash, walletStore, {
                    amount,
                }))
            ) {
                if (props.onTx !== undefined) {
                    await props.onTx();
                }
                setIsConfirmedTx(true);
                await resetForm();
            } else {
                setIsFaildedTx(true);
            }
        } catch (error) {
            setIsFaildedTx(true);
        } finally {
            setIsProcessingTx(false);
        }
    };
    //--------------------------------------
    return {
        appStore,
        isRefreshing,
        isProcessingTx,
        isFaildedTx,
        setIsFaildedTx,
        isConfirmedTx,
        setIsConfirmedTx,
        processingTxMessage,
        processingTxHash,
        isValidTx,
        amount,
        setAmount,
        handleBtnGetTokenGovTx,
    };
    //--------------------------------------
}
